import Builder from '../components/Builder';

export default function BuilderBlocksBuilder() {
  return <Builder />
}
